<template lang="html">
  <div class="card border mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-2">
          <h6 class="mb-0">Full Name</h6>
        </div>
        <div class="col-sm-7 text-secondary">
          {{ firstName + " " + lastName }}
        </div>
        <div class="col-sm-3 text-center">
          <b-button variant="primary" @click="updateName()">Update Name</b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-2">
          <h6 class="mb-0">Username</h6>
        </div>
        <div class="col-sm-6 text-secondary">
          {{ userName }}
        </div>
      </div>
      <hr>
      <div class="b-container">
        <b-alert v-model="showChangeEmailAlert" variant="success" dismissible>
          Your email change has been verified.
        </b-alert>
        <b-alert v-model="showRevertEmailAlert" variant="info" dismissible>
          Your email change has been canceled.
        </b-alert>
        <b-alert v-model="changeEmailPending" variant="info" dismissible>
          Follow instructions in the email to complete your email change.
        </b-alert>
      </div>
      <div class="row">
        <div class="col-sm-2">
          <h6 class="mb-0">Email</h6>
        </div>
        <div class="col-sm-7 text-secondary">
          {{ email }}
          <small v-if="isVerified" class="text-muted ml-3">(Email Verified)
            <i class="fa-solid fa-user-check"></i>
          </small>
          <small v-else class="text-danger ml-3">(Email not Verified)
            <i class="fa-solid fa-user-slash"></i>
          </small>
        </div>
        <div class="col-sm-3 text-center">
          <b-button v-if="isVerified" variant="primary" @click="updateEmail()">Change Email</b-button>
          <b-button v-else variant="outline-secondary" @click="verifyEmail()">Verify Email</b-button>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-2">
          <h6 class="mb-0">Password</h6>
        </div>
        <div class="col-sm-7 text-secondary">
          *********************************
          <small class="text-muted ml-3">(Secured)
            <i class="fa-solid fa-lock"></i>
          </small>
        </div>
        <div class="col-sm-3 text-center">
          <b-button variant="primary" @click="updatePassword()">Change Password</b-button>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-12">
          <router-link class='btn btn-danger'
                       alt="Delete My Account" title="Delete My Account"
                       :to="{ name: 'Delete'}">
            <i class="fa fa-times-circle mr-2"></i> <strong>Delete My Account</strong>
          </router-link>
        </div>
      </div>
    </div>
    <UpdateNameModal></UpdateNameModal>
    <UpdateEmailModal></UpdateEmailModal>
    <UpdatePasswordModal></UpdatePasswordModal>
  </div>
</template>

<script>
import {mapActions, mapGetters,} from 'vuex'
import UpdateNameModal from "./UpdateNameModal.vue";
import UpdateEmailModal from "./UpdateEmailModal.vue";
import UpdatePasswordModal from "./UpdatePasswordModal.vue";

export default {
  components: {
    UpdatePasswordModal,
    UpdateEmailModal,
    UpdateNameModal,
  },
  data() {
    return {
      changeRevertEmailSuccess: false,
      changeRevertEmailType: null,
    }
  },
  created() {
    if (this.isChangeEmail) {
      this.changeRevertEmailSuccess = this.isChangeEmail
      this.changeRevertEmailType = this.changeEmailType
      this.resetChangeEmail()
    }
  },
  computed: {
    ...mapGetters({
      isLoading: "user/profile/isLoading",
      userVuex: "user/profile/id",
      firstName: "user/profile/firstName",
      lastName: "user/profile/lastName",
      userName: "user/profile/userName",
      email: "user/profile/email",
      isVerified: "user/profile/isVerified",
      changeEmailPending: "user/profile/changeEmailPending",
      isChangeEmail: "user/change_email/emailChangeStatus",
      changeEmailType: "user/change_email/emailChangeType",
    }),
    showChangeEmailAlert: {
      get() {
        return this.changeRevertEmailSuccess && this.changeRevertEmailType === 'change email'
      },
    },
    showRevertEmailAlert: {
      get() {
        return this.changeRevertEmailSuccess && this.changeRevertEmailType === 'revert email'
      },
    },
  },
  methods: {
    ...mapActions({
      resetChangeEmail: "user/change_email/reset",
    }),
    verifyEmail() {
      this.$bvModal.show('not-verified-modal')
    },
    updateName() {
      this.$bvModal.show('update-name-modal')
    },
    updateEmail() {
      this.$bvModal.show('update-email-modal')
    },
    updatePassword() {
      this.$bvModal.show('update-password-modal')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
